/**
 * Maps settlement rail ids to `depositDetails.pdfExplainers.*` translation
 * keys for the settlement-instructions PDF. Pure so the key selection is
 * unit-testable; the component resolves the keys through next-intl.
 */

const RAIL_EXPLAINER_KEY: Record<string, string> = {
  FP: "fp",
  CHAPS: "chaps",
  SWIFT: "swift",
  SCT: "sepa",
  SCTINST: "sepaInstant",
};

/**
 * Returns the ordered list of explainer keys (under
 * `depositDetails.pdfExplainers`) for a settlement method: the generic
 * accepted-rails and currency-only lines, one per-rail explainer for every
 * KNOWN rail (unknown rail ids are skipped rather than guessed at), and the
 * no-SWIFT warning when international transfers aren't accepted.
 *
 * Deliberately NO one-account/sibling framing here: the PDF describes the
 * single detail set the sender receives — telling a sender about the
 * customer's other sets is noise (product decision, Aug 2026).
 */
export function buildSettlementPdfExplainerKeys(
  railIds: readonly string[],
  acceptsSwift: boolean
): string[] {
  const railKeys = railIds
    .map((id) => RAIL_EXPLAINER_KEY[id])
    .filter((key): key is string => Boolean(key));

  return [
    "acceptedRails",
    "currencyOnly",
    ...railKeys,
    ...(acceptsSwift ? [] : ["noSwift"]),
  ];
}
